import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useProducts } from "../lib/ProductsContext";
import { optimizeImg } from "../lib/img";

const MotionLink = motion(Link);

export default function Categories() {
  const { categories } = useProducts();

  return (
    <section
      id="kategoriler"
      className="py-20 md:py-28 lg:py-32 bg-white"
      data-testid="categories-section"
    >
      <div className="frida-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 lg:mb-16 gap-6">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3" data-testid="categories-eyebrow">
              · Koleksiyonlar ·
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1]" data-testid="categories-title">
              Her An İçin <span className="italic text-[#A85C34]">Doğru</span> Çiçek
            </h2>
          </div>
          <p className="text-[#555555] text-lg max-w-md leading-relaxed" data-testid="categories-subtitle">
            Doğum gününden yıldönümüne, her özel an için özenle hazırlanmış {categories.length} kategori.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6 lg:gap-7">
          {categories.slice(0, 10).map((cat, i) => (
            <MotionLink
              key={cat.id}
              to={`/kategori/${cat.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 5) * 0.05, ease: "easeOut" }}
              className="group relative aspect-[3/4] rounded-3xl overflow-hidden lift-card cursor-pointer block isolate"
              data-testid={`category-card-${cat.id}`}
            >
              <div className="absolute inset-0 zoom-on-hover">
                <img
                  src={optimizeImg(cat.image, 450)}
                  alt={cat.name}
                  width="450"
                  height="600"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/0" />

              <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/95 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
                <ArrowUpRight className="w-4 h-4 text-[#222222]" />
              </div>

              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 lg:p-6 flex flex-col justify-end min-h-[5.5rem]">
                <div className="text-[10px] tracking-[0.25em] uppercase text-white/75 mb-1.5 font-medium">
                  Kategori
                </div>
                <h3
                  className="font-serif text-base md:text-xl lg:text-2xl text-white leading-snug line-clamp-2 text-balance"
                  data-testid={`category-name-${cat.id}`}
                >
                  {cat.name}
                </h3>
              </div>
            </MotionLink>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link
            to="/kategoriler"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white border border-[#222222] text-[#222222] rounded-full font-medium hover:bg-[#222222] hover:text-white transition-all"
            data-testid="categories-view-all"
          >
            Tüm Kategorileri Gör
          </Link>
        </div>
      </div>
    </section>
  );
}
